import { gql } from 'graphql-request';

export const FETCH_LATEST_MOVIES_DATA_QUERY = gql`
  query ($filter: MovieFilter!) {
    movies(filter: $filter) {
      __typename
      id
      image {
        list
        cover
        logo
      }
      contents {
        ... on Movie {
          id
          title
          originalTitle
          description
          image {
            list
            cover
            listClean
            sticker
            svodCover
            appCover
            channelSquare
            channelList
            square
            portrait
            logo
            verticalBanner
            mobileBanner
            desktopBanner
          }
          shortDescription
          businessType
          billingType
          duration
          contentOwner
          genres {
            id
            value
          }
          languages
          assetType
          assetSubType
          releaseDate
          actors
          ageRating
          audioLanguages
          subtitleLanguages
          eventLive
          tags
          introStartTime
          introEndTime
          tier
          playDate
          seoTitle
          slug
          webUrl
          rating
          playedDuration
        }
      }
    }
  }
`;
